import React, { ReactElement } from "react";
import Layout from "Layout";
import AddNewOrderForm from "./AddNewOrderForm";
import styles from "./styles.module.scss";

function AddNewOrder(): ReactElement {
  return (
    <Layout>
      <div className={styles.addNewOrderPageInfo}>
        <h1>Add New Data</h1>
        <div className={styles.barContainer}>
          <div className={styles.bar} />
        </div>
        <div className={styles.addNewOrderForm}>
          <AddNewOrderForm />
        </div>
      </div>
    </Layout>
  );
}

export default AddNewOrder;
